import ComponentManager from '@/Management/ComponentManager';
import TwoFactorPopupViewFactory from '@/Components/TwoFaktorAuth/PopupWindow/TwoFactorPopupViewFactory';
import TwoFactorSelfServiceViewViewModel from '@/Components/TwoFaktorAuth/SelfService/TwoFactorSelfServiceViewViewModel';
import TwoFactorSelfServiceViewWindow from '@/Components/TwoFaktorAuth/SelfService/TwoFactorSelfServiceViewWindow';
import {ITwoFactorPopupViewFactoryConstructorParameter, ITwoFactorSelfServiceViewViewModelParameter} from '#/DefaultViewExtensionInterfaces';

interface ITwoFactorSelfServiceViewFactoryConstructorParameter extends ITwoFactorPopupViewFactoryConstructorParameter {
    
}

export default class TwoFactorSelfServiceViewFactory extends TwoFactorPopupViewFactory {
    private TwoFactorAuthSelfServiceViewViewModel = ComponentManager.getViewModel<typeof TwoFactorSelfServiceViewViewModel>('TwoFactorSelfServiceViewViewModel');
    private TwoFactorAuthSelfServiceViewWindow = ComponentManager.getControl<typeof TwoFactorSelfServiceViewWindow>('TwoFactorSelfServiceViewWindow');
    
    public viewModel: TwoFactorSelfServiceViewViewModel;

    /**
     * @override
     */
    public window: TwoFactorSelfServiceViewWindow;

    public constructor(params: ITwoFactorSelfServiceViewFactoryConstructorParameter) {
        super(params);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {

        if (this.viewModel == null) {
            this.viewModel = this.createViewModel(this.createViewModelParameter());
        }

        if (this.window == null) {
            this.window = this.createView(this.viewModel);
        }

        const tuple = this.window.getTuple();
        return tuple.control;
    }
    
    protected createViewModel(parameter: ITwoFactorSelfServiceViewViewModelParameter): TwoFactorSelfServiceViewViewModel {
        return new this.TwoFactorAuthSelfServiceViewViewModel(parameter);
    }

    protected createView(viewModel: TwoFactorSelfServiceViewViewModel): TwoFactorSelfServiceViewWindow {
        return new this.TwoFactorAuthSelfServiceViewWindow(viewModel);
    }
}

ComponentManager.setFactory('TwoFactorSelfService', TwoFactorSelfServiceViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
// Registrierung unter 2 Namen, damit bestehende Stellen nicht auf den neuen Namen angepasst werden müssen
ComponentManager.setFactory('2FA', TwoFactorSelfServiceViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
